import * as React from 'react'

const SvgTutrosCalenderIcon = ({ stroke }) => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9.7998H1M14 1.7998V5.7998M6 1.7998V5.7998M5.8 21.7998H14.2C15.8802 21.7998 16.7202 21.7998 17.362 21.4728C17.9265 21.1852 18.3854 20.7263 18.673 20.1618C19 19.52 19 18.68 19 16.9998V8.5998C19 6.91965 19 6.07957 18.673 5.43783C18.3854 4.87335 17.9265 4.41441 17.362 4.12679C16.7202 3.7998 15.8802 3.7998 14.2 3.7998H5.8C4.11984 3.7998 3.27976 3.7998 2.63803 4.12679C2.07354 4.41441 1.6146 4.87335 1.32698 5.43783C1 6.07957 1 6.91965 1 8.5998V16.9998C1 18.68 1 19.52 1.32698 20.1618C1.6146 20.7263 2.07354 21.1852 2.63803 21.4728C3.27976 21.7998 4.11984 21.7998 5.8 21.7998Z"
      stroke={stroke ? stroke : '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgTutrosCalenderIcon
